import { ChevronRight, type LucideIcon } from "lucide-react";
import Image from "next/legacy/image";
import Link from "next/link";

interface FeatureCardsProps {
	features: {
		title: string;
		description: string;
		thumbnailUrl: string;
		icon?: LucideIcon;
		links: {
			label: string;
			href: string;
		}[];
	}[];

	title: string;
}

const FeatureCards = ({ features, title }: FeatureCardsProps) => {
	return (
		<section className="container mx-auto my-12 flex flex-col items-center gap-12">
			<h3 className="text-center font-bold text-3xl dark:text-white">
				{title}
			</h3>

			<div className="mx-auto grid max-w-5xl grid-cols-1 gap-10 md:grid-cols-2">
				{features.map((item) => (
					<div
						key={item.title}
						className="flex flex-col justify-between gap-5 rounded-lg bg-slate-50 p-6 dark:bg-slate-700"
					>
						<div className="flex flex-col gap-2">
							{item.icon && (
								<item.icon className="h-6 w-6 text-sky-600 dark:text-sky-400" />
							)}
							<h4 className="font-semibold text-xl dark:text-white">
								{item.title}
							</h4>
							<p className="mb-2 text-slate-600 dark:text-slate-300">
								{item.description}
							</p>
							{!!item.links.length && (
								<ul className="flex flex-col gap-1">
									{item.links.map((link) => (
										<li key={link.href}>
											<Link
												href={link.href}
												target="_blank"
												className="flex items-center text-sky-600 hover:text-sky-700 dark:text-sky-400 dark:hover:text-sky-300"
											>
												{link.label}
												<ChevronRight className="-mr-1 h-4 w-4" />
											</Link>
										</li>
									))}
								</ul>
							)}
						</div>

						<div className="relative -mb-2 aspect-video w-full overflow-hidden rounded-xl">
							<Image
								src={item.thumbnailUrl}
								layout="fill"
								lazyBoundary="5px"
								alt={item.title + " thumbnail"}
								className="object-cover"
								loading="lazy"
							/>
						</div>
					</div>
				))}
			</div>
		</section>
	);
};

export default FeatureCards;
